// extracted by mini-css-extract-plugin
export default {"container":"Slide_container__ELeye","content":"Slide_content__Xb5Ti","item":"Slide_item__2MQm0","nav":"Slide_nav__MkcyL"};